import { createRouter, createWebHistory } from "vue-router";
import { pcRoutes, h5Routes } from "./routes";
import useWeChatSdk from "@/hooks/useWeChatSdk";
import store from "@/store";

import { setTitle, getHostname, isWechatBrowser } from "@/utils/help";

import { codeExchangeToken } from "@/api/user";

const isMobile = window.document.body.clientWidth - 1 < 1200;
const _isWechatBrowser = isWechatBrowser();
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: isMobile ? h5Routes : pcRoutes,
});

const H5WhiteList = ["Error"];
// const H5BlackList = ["Pay"];
// 1-外链;2-子菜单;5-会议;6-资讯;7-附件;8-课程 11-图文 12-图文+附件 13-投稿 14-日程
// const RoutesPath = {
//   11: "/richText",
//   12: "/attachments",
//   13: "/contribute",
//   14: "/chedule",
// };
router.beforeEach(async (to, from, next) => {
  const config = store.getters["config/getConfig"];
  const userInfo = store.getters["user/getUserInfo"];

  if (H5WhiteList.includes(to.name)) {
    return next();
  }

  // 获取配置
  if (!config) {
    let hasAppid = false;
    const url =
      process.env.NODE_ENV == "development"
        ? "test2026.i-bhc.org.cn"
        : getHostname();
    hasAppid = await store.dispatch("config/getMeetingConfigAction", {
      type: "url",
      url,
    });
    const res = await store.dispatch("config/getTabListAction");
    setTitle(store.getters["config/getConfig"].platformName);
    if (!hasAppid || !res) {
      return next("/error");
    }
  }

  if (!to.name) {
    return next("/");
  }

  const { _code } = to.query;
  // 换取token
  if (_code) {
    try {
      let { results: newToken } = await codeExchangeToken({ code: _code });
      if (newToken) {
        newToken = newToken.split(" ")[1];
        localStorage.setItem("token", newToken);
      } else {
        // 清除本地存储 token
        localStorage.clear();
      }
    } catch (error) {
      // 清除本地存储 token
      localStorage.clear();
    }
    delete to.query._code;
    return next({ ...to, query: to.query, replace: true });
  }

  if (!isMobile && to.fullPath == "/") {
    const pcIndexPath = store.getters["config/getPcIndexPath"];
    // pc端跳转去首页
    return next(pcIndexPath);
  }
  const token = localStorage.getItem("token");
  // 有token
  if (token) {
    if (!userInfo) {
      await store.dispatch("user/getUserInfoAction");
    }
    next();
  } else {
    if (isMobile) {
      // 默认不走微信授权
      // if (_isWechatBrowser) {
      //   // 微信授权
      //   const { appid, platformId } = store.getters["config/getConfig"];
      //   const wechat_redirect = encodeURIComponent(
      //     `${
      //       process.env.VUE_APP_WECHAT_REDIRECT
      //     }?_back_url=${encodeURIComponent(location.href)}`
      //   );
      //   window.location = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${wechat_redirect}&response_type=code&scope=snsapi_userinfo&state=${platformId}#wechat_redirect`;
      //   return;
      // }
      // if (H5BlackList.includes(to.name)) {
      //   next("/");
      // } else {
      next();
      // }
    } else {
      const pcIndexPath = store.getters["config/getPcIndexPath"];
      if (to.name === "My") {
        // pc端跳转去首页
        next(pcIndexPath);
      } else {
        next();
      }
    }
  }
});

router.afterEach(() => {
  if (_isWechatBrowser) {
    const config = store.getters["config/getConfig"];
    const { shareTitle, shareContent, shareImageUrl } = config;
    if (shareTitle) {
      useWeChatSdk(shareTitle, shareContent, location.href, shareImageUrl);
    }
  }
});

export default router;
